import { render, staticRenderFns } from "./CategoryPost.vue?vue&type=template&id=15fc927b&scoped=true&lang=pug&"
import script from "./CategoryPost.vue?vue&type=script&lang=js&"
export * from "./CategoryPost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15fc927b",
  null
  
)

export default component.exports